module.exports = __webpack_public_path__ + "r-v3/img/sticker_22.49a1edd8.svg";